export { default as StaggeredText } from './staggered-text';
